import Typography from '@/components/Typography';
import { TextStyles } from '@/constants';
import styled from 'styled-components';

import { BaseDisabledStylesAsObj } from '@/components/Button/Button.styles';
// SVG imports
import ArrowBackIcon from 'public/images/icons/arrow_back.svg';
import KeyboardArrowRightIcon from 'public/images/icons/keyboard_arrow_right.svg';

export const Title = styled(Typography)(({ theme }) => ({
  color: theme.colors.highEmphasisBlack,
}));

export const StyledArrowBackIcon = styled(ArrowBackIcon)(({ theme }) => ({
  path: {
    fill: theme.colors.blue,
  },
  width: theme.spacing[20],
  height: theme.spacing[20],
}));

export const StyledArrowRightIcon = styled(KeyboardArrowRightIcon)(({ theme }) => ({
  width: theme.spacing[20],
  height: theme.spacing[20],
}));

export const BackButton = styled.button<{ disabled?: boolean }>(({ theme, disabled }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: `${theme.spacing[4]}`,
  padding: 0,
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
  alignSelf: 'flex-start',
  marginBottom: theme.spacing[24],
  minHeight: theme.spacing[36],

  ...(disabled && BaseDisabledStylesAsObj),
}));

export const BackButtonText = styled(Typography).attrs({
  variant: TextStyles.Button,
})(({ theme }) => ({
  textTransform: 'uppercase',
  color: theme.colors.blue,
}));

export const PrivacyContainer = styled.div<{ isDesktopPMT: boolean }>(({ theme, isDesktopPMT }) => ({
  marginTop: theme.spacing[20],
  display: 'flex',
  flexDirection: 'column',
  gap: `${isDesktopPMT ? theme.spacing[20] : theme.spacing[16]}`,
  width: '100%',
}));

export const ItemContainer = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing[16],
  background: theme.colors.highEmphasisWhite,
  borderRadius: '4px',
  boxShadow: '0px 0.5px 2px 0px rgba(96, 97, 112, 0.16), 0px 0px 1px 0px rgba(40, 41, 61, 0.08)',
  cursor: 'pointer',
  [`${theme.mediaBreakpointUp.lg}`]: {
    padding: `${theme.spacing[24]} ${theme.spacing[20]}`,
  },
}));

export const ItemContent = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: `${theme.spacing[8]}`,
}));

export const ItemArrow = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const DataPrivacyWrapper = styled.div(({ theme }) => ({
  padding: theme.spacing[20],
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  background: theme.colors.pageBackground,
  minHeight: 679,

  [`${theme.mediaBreakpointUp.lg}`]: {
    maxWidth: 800,
    padding: `${theme.spacing[40]} 0`,
  },
}));
